// Labels for the MFB piston motor charts. The charts are written in Spanish.
// English pages pass locale="en". Numbers and part codes stay as written.

const EXACT = {
	"Motor de pistón MFB": "MFB piston motor",
	"Desglose del código de modelo": "Model code breakdown",
	"Sellos especiales": "Special seals",
	"Serie del modelo": "Model series",
	"Caudal a 1800 rpm": "Flow at 1800 rpm",
	"Tipo de montaje": "Mounting type",
	Rotación: "Rotation",
	"Extremo del eje": "Shaft end",
	"Conexiones de puerto": "Port connections",
	"Número de diseño": "Design number",
	Código: "Code",
	Descripción: "Description",
	Caudal: "Flow",
	"Omitir si no se requiere": "Omit if not required",
	Motor: "Motor",
	"Desplazamiento fijo": "Fixed displacement",
	"Tipo en línea": "Inline type",
	"Soporte de pie": "Foot bracket",
	"Omitir para montaje por brida": "Omit for flange mounting",
	"Para el kit de soporte de pie por separado, consulte la página 13 de la literatura.":
		"For a separate foot bracket kit, see page 13 of the literature.",
	Bidireccional: "Bi-directional",
	"Extremo del eje (solo MFB5/10)": "Shaft end (MFB5/10 only)",
	"Eje estándar": "Standard shaft",
	"Eje opcional": "Optional shaft",
	"* El eje opcional está disponible solo para intercambiar unidades de diseño anterior (-10). No se recomienda para operación por encima de 1800 RPM y 100 bar (1500 psi).":
		"* The optional shaft is available only to interchange with earlier (-10 design) units. Not recommended for operation above 1800 RPM and 100 bar (1500 psi).",
	"Conexiones de puerto (MFB45)": "Port connections (MFB45)",
	"Puertos con brida SAE de 4 pernos": "SAE 4-bolt flanged ports",
	"Número de diseño (sujeto a cambio)": "Design number (subject to change)",
	"Diseño 21 (MFB5)": "21 design (MFB5)",
	"Diseño 31 (MFB10)": "31 design (MFB10)",
	"Diseño 10 (MFB20, 29 y 45)": "10 design (MFB20, 29 and 45)",
	Especificaciones: "Specifications",
	Modelo: "Model",
	"Desplazamiento cm³ (pulg.³)/rev.": "Displacement cm³ (in³)/rev.",
	"Caudal LPM (GPM) a 1800 RPM": "Flow LPM (GPM) at 1800 RPM",
	"Velocidad de operación RPM": "Operating speed RPM",
	"Presión bar (psi)": "Pressure bar (psi)",
	"Par de salida Nm (lb in)": "Output torque Nm (lb in)",
	"Peso (lb)": "Weight (lb)",
	Nominal: "Rated",
	"Máx.": "Max.",
};

export function translate(locale, value) {
	if (locale !== "en" || typeof value !== "string") return value;
	return EXACT[value] ?? value;
}
